<template>
  <b-modal
    :visible="value"
    title="ยืนยันการเพิ่มผู้เรียน"
    size="lg"
    centered
    header-class="border-bottom-0"
    footer-class="border-top-0"
    no-close-on-backdrop
    @change="$emit('input', $event)"
  >
    <b-row v-for="field in previewFields" :key="field.label" class="mb-3">
      <b-col md="5">{{ field.label }}:</b-col>
      <b-col md="7">{{ field.value }}</b-col>
    </b-row>

    <template v-slot:modal-footer>
      <b-button
        variant="secondary"
        :disabled="submitting"
        @click="$emit('input', false)"
      >
        ยกเลิก
      </b-button>
      <b-button variant="success" :disabled="submitting" @click="$emit('confirm')">
        <b-spinner v-if="submitting" small></b-spinner>
        ยืนยันการเพิ่มผู้เรียน
      </b-button>
    </template>
  </b-modal>
</template>

<script>
// Preview of the learner about to be created, shown before the add request is sent (Wannasorn only).
import { gradeLevelText } from "@/helpers/grade-level";
import { genderText } from "@/helpers/gender";

const THAI_MONTHS = [
  "มกราคม",
  "กุมภาพันธ์",
  "มีนาคม",
  "เมษายน",
  "พฤษภาคม",
  "มิถุนายน",
  "กรกฎาคม",
  "สิงหาคม",
  "กันยายน",
  "ตุลาคม",
  "พฤศจิกายน",
  "ธันวาคม",
];

export default {
  props: {
    value: { type: Boolean, default: false },
    form: { type: Object, required: true },
    submitting: { type: Boolean, default: false },
  },
  computed: {
    thaiFullName() {
      return `${this.form.firstName} ${this.form.lastName}`.trim() || "-";
    },
    // Stored as an ISO date; displayed in Thai with a Buddhist-era year.
    dobPreviewText() {
      if (!this.form.dateOfBirth) return "-";
      const [year, month, day] = this.form.dateOfBirth.split("-").map(Number);
      if (!year || !month || !day) return "-";
      return `${day} ${THAI_MONTHS[month - 1]} ${year + 543}`;
    },
    previewFields() {
      const form = this.form;
      const enFullName = `${form.firstNameEn} ${form.lastNameEn}`.trim() || "-";

      return [
        { label: "ชื่อ - นามสกุล (ภาษาไทย)", value: this.thaiFullName },
        { label: "ชื่อ - นามสกุล (ภาษาอังกฤษ)", value: enFullName },
        { label: "ชื่อเล่น", value: form.nickName || "-" },
        { label: "อีเมล", value: form.email || "-" },
        { label: "วันเดือนปีเกิด (ค.ศ 4 หลัก)", value: this.dobPreviewText },
        { label: "เลขประจำตัวประชาชน", value: form.idCard || "-" },
        { label: "เพศ", value: genderText(form.gender) },
        { label: "ระดับชั้น", value: gradeLevelText(form.gradeLevel) },
        { label: "โรงเรียน", value: form.education || "-" },
        { label: "เบอร์โทรศัพท์", value: form.phoneNumber || "-" },
        { label: "เบอร์โทรผู้ปกครอง", value: form.parentPhone || "-" },
        { label: "เกี่ยวกับผู้เรียน", value: form.about || "-" },
      ];
    },
  },
};
</script>
